// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3YnLD","container":"styles_container__1yfri","title":"styles_title__-U9hc","wrapper":"styles_wrapper__1oZB3","answer":"styles_answer__3S5bf"};